import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface IManualPromoActivationDialogData {
  code: string;
  minDepositSum: number;
}

@Component({
  selector: 'app-manual-promo-activation-dialog',
  templateUrl: './manual-promo-activation-dialog.component.html',
  styleUrls: ['./manual-promo-activation-dialog.component.scss']
})
export class ManualPromoActivationDialogComponent {
  public readonly form: FormGroup = this.fb.group({
    depositAmount: [
      this.data.minDepositSum,
      [
        Validators.required,
        Validators.min(this.data.minDepositSum),
        Validators.pattern(/^\d+$/)
      ]
    ]
  });

  constructor(
    private readonly fb: FormBuilder,
    private readonly dialogRef: MatDialogRef<ManualPromoActivationDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public readonly data: IManualPromoActivationDialogData
  ) {}

  public submit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.dialogRef.close(Number(this.form.value.depositAmount));
  }

  public cancel(): void {
    this.dialogRef.close();
  }
}
